import { Component, OnInit ,ViewChild, Input, ElementRef, HostListener, SimpleChanges} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;

//活动时间排期表
@Component({ 
  selector: 'sw-time-schedule',
  templateUrl: './sw-time-schedule.component.html',
  styleUrls: ['./sw-time-schedule.component.css']
})
export class SwTimeScheduleComponent implements OnInit {
//样式3 聚焦搜索框时 出现带条件的样式
 
initWidth:any = 0
tableWidth:any = 1300  //表格盒子总宽度
itemWidth:any =75   //每个月份或表格格子宽度
gridNumWidth:any = '75px';//每行表格格子个数
tableHeight:any = '703px' ; //表格的高度，根据地址数据的长度决定 每行高50，大于等于13时，高度为 '703px',小于13时，为 addressList.length*50+50
//纵坐标--展馆信息（一定要正确排序，涉及到 top 和 height）
@Input() addressList:any[] = [
  // {name:'二号大厅',id:'1'},
  // {name:'一号大厅',id:'2'},
  // {name:'南1',id:'3'},
  // {name:'南2',id:'4'},
  // {name:'南3',id:'5'},
  // {name:'南4',id:'6'},
]

//横坐标--时间段（年份和月份） 根据expList展览信息的年（类别）=》获取数组长度，根据最小时间（年、月）和最大时间（年、月）获取范围
//目前的坐标年份只支持相连续的两年 即只含有两项
rangeList:any[] = [
  // {year:2021,month:[1,2,3,4,5,6,7,8,9,10,11,12]},
  // {year:2022,month:[1,2,3,4]}
]

monthNum:any[]= []

//展览信息（含 1.展览主题名称 2.起始和结束时间 3.展览的展馆地址（数组形式） 4.是否已开展 5.是否有筹展费 6.是否已开基本陈列）
@Input() expList:any[] = [
  // {id:1,startTime:'2021-01-31',endTime:'2022-01-09',address:['二号大厅'],name:'科学技术与工业展',color:'rgba(0, 255, 255, 0.24)'},
  // {id:2,startTime:'2021-01-01',endTime:'2021-06-28',address:['一号大厅'],name:'屹立东方-馆藏经典美术作品展',color:'rgba(95,222,95,0.24)'},
  // {id:3,startTime:'2021-06-30',endTime:'2022-01-31',address:['一号大厅'],name:'精神的力量',color:'rgba(95,148,22,0.24)'},
  // {id:4,startTime:'2021-01-01',endTime:'2021-03-15',address:['南1','南2'],name:'中国戏曲展',color:'rgba(222,215,95,0.24)'},
  // {id:5,startTime:'2021-06-25',endTime:'2021-07-20',address:['南1','南2','南3','南4'],name:'新时代建设成就巡礼展',color:'rgba(222,122,95,0.24)'},
]
//展览类型 
@Input() expType:any[] = [
  // {id:1,text:'已开基本陈列、专题展览',color:'rgba(0, 255, 255, 0.24)'},
  // {id:2,text:'有筹展览',color:'rgba(95,222,95,0.24)'},
  // {id:3,text:'已开展览',color:'rgba(95,148,22,0.24)'},
  // {id:4,text:'未开展览',color:'rgba(222,215,95,0.24)'},
  // {id:5,text:'空置展厅',color:'#ffffff'},
] 
//展览右侧标题
@Input() expTitle:any = ''
//展览左侧侧标题
@Input() expLeftTitle:any = ''
 idt:any = ''
 addressListCopy:boolean = false
 expListCopy:boolean = false
 allWidth:any = '100%'
  constructor(
    private router: Router,
    private activedRouter: ActivatedRoute,
    private el: ElementRef, //获取dom元素
  ) { 
 
  }

  ngOnInit() {
    this.idt = 'timeTable' +  Math.random().toString().split(".")[1]
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if(changes && changes['addressList']) {
     // console.log('jjjjjjjj')
      if(changes['addressList']['currentValue']){
        this.addressListCopy = true
      }
     }
     if(changes && changes['expList']) {
      //console.log('lllll')
      if(changes['expList']['currentValue']){
        this.expListCopy = true
      }
     }
     if(this.addressListCopy && this.expListCopy){
      this.getTimeRange()
     }
     if(changes && changes['addressList'] && changes['expList']) {
      if(!changes['addressList']['firstChange'] && !changes['expList']['firstChange']){
        if(changes['addressList']['currentValue'] && changes['expList']['currentValue']){
          this.getTimeRange()
        }
      }
     }
  }


  //先根据展览信息 确定展览时间的最早和最晚时间
  getTimeRange(){
    //先将每个展览的起始时间拿到，找到最早的的一个，注意只需要年份和月份
    let range = this.getMinAndMaxTime()
    this.rangeList = []
   // console.log('展览时间范围',range);
    if(range){
      //如果起始时间和结束时间是在同一年
      if(range[0]['year'] == range[1]['year']){  
        this.rangeList = [{year:range[0]['year'],month:[]}]
        for (let m = range[0]['month']; m <= range[1]['month']; m++) {
          this.rangeList[0]['month'].push(m)
        }
      } else {
        //如果起始时间和结束时间不是在同一年
        //获取年限数组  先获取最小年限的月份、获取最大年限的月份，中间的年限月份为1月到12月
        //获取总年份数据
        //最小的年份
        let minYear = range[0]['year']
        //最大的年份
        let maxYear = range[1]['year']
        let temp = []
        for(let i = minYear; i<=maxYear; i++){
          temp.push(i)
        }
       // console.log(temp)
        for(let i=0;i<temp.length;i++){
          this.rangeList[i] = {year:temp[i],month:[]}
          let minM , maxM
          //最小年限
          if(temp[i] == range[0]['year']){
            minM = range[0]['month']
            maxM = 12
          }else if(temp[i] == range[1]['year']){
            //最大年限
            minM = 1
            maxM = range[1]['month']
          }else {
            //中间年限
            minM = 1
            maxM = 12
          }
          for (let m = minM; m <= maxM; m++) {
            this.rangeList[i]['month'].push(m)
          }
        }
        // for (let i = 0; i <= 1; i++) {
        //   this.rangeList[i] = {year:range[i]['year'],month:[]}
        //   let minM , maxM
        //   if(i != range.length-1){  //如果不是最后一年
        //     minM = range[i]['month']
        //     maxM = 12
        //   } else { // 如果是最后一年
        //     minM = 1
        //     maxM = range[i]['month']
        //   }
        //   for (let m = minM; m <= maxM; m++) {
        //     this.rangeList[i]['month'].push(m)
        //   }
          
        // }
      }
      // console.log('this.rangeList',this.rangeList);
      let num = 0
      this.rangeList.forEach(v=>{
        num += v.month.length
      })
      this.monthNum = Array(num).map((x,i)=>i); // [0,1,2,3,4]
      this.gridNumWidth = num * this.itemWidth +'px'
      //tableHeight:any = '703px' ; //表格的高度，根据地址数据的长度决定 每行高50，大于等于13时，高度为 '703px',小于13时，为 addressList.length*50+50
      if(this.addressList.length < 13){
        this.tableHeight = this.addressList.length*50+53 +'px'
        $("#right_div2").css('overflow-y','hidden')
      }else {
        this.tableHeight = '703px'
      }
      // console.log('monthNum')
      // console.log(this.monthNum)
      // console.log(this.rangeList)
      //获取总table宽度
   }
  }
  ngAfterViewInit(): void {
   this.initWidth = $("#"+this.idt).width()
    let tember = setInterval(()=>{
      let wid =  $("#"+this.idt).width()
      if(this.initWidth == wid && this.addressListCopy && this.expListCopy && this.rangeList.length > 0){
        $("#"+this.idt).css('display','block')
        this.getWidth()
        clearInterval(tember)
      }
    },300)
    var right_div2 = document.getElementById("right_div2");
       right_div2.onscroll = ()=>{
          var right_div2_top = right_div2.scrollTop;
          var right_div2_left =right_div2.scrollLeft;
          document.getElementById("left_div2").scrollTop = right_div2_top;
          document.getElementById("right_div1").scrollLeft = right_div2_left;
     }
  }
  getWidth(){
    //let widt = this.el.nativeElement.querySelector("#timeTable").clientWidth
    // let allWidth = $("#"+this.idt).width()
    // let gridW = allWidth - 50
    // let itemW = gridW/this.monthNum.length - 0.1
   let  boxWidth = $("#"+this.idt).width()
   let tableWidth = this.gridNumWidth.split('px')[0]-0
   let trueWidth = tableWidth + 50 + 4
   if(boxWidth > trueWidth){
    this.allWidth = trueWidth + 'px'
   }else {
    this.allWidth = '100%'
   }
    this.getPositionByItem()
  }

  show(){
   console.log('haha')
    let tember = setInterval(()=>{
      if(this.rangeList.length > 0){
        // $("#"+this.idt).css('display','block')
        this.getWidth()
        clearInterval(tember)
      }
    },10)
  }
  //获取每个展览信息的位置、宽、高
  getPositionByItem(){
    $('#right_div2').find('.exp').remove()
    this.expList.forEach(el=>{
      // let dom = 'exp'+el.id
      let positon = this.getPosition(el)
      // $("#"+this.idt).find('#'+dom).html()
      // $("#"+this.idt).find('#'+dom).append(positon)
      if(positon){
        $('#right_div2').append(positon)
      }
    })
  }
  //保留一位小数
  getnum(num){
    var a = num+'';
    var b = "";
    if (a.indexOf(".") > 0) {
        b = a.substring(0, a.indexOf(".") + 2);
    }
   return parseFloat(b) 
  }
  //根据展览的起始和结束时间获取所有展览涉及到的最早时间和最晚时间，形成横坐标
  getMinAndMaxTime(){
    //  console.log(this.expList)
    //  console.log(this.addressList)
     if(this.expList.length > 0 && this.addressList.length > 0){
        let min = this.expList[0]['startTime']   
        let max = this.expList[0]['endTime'] 
        for (let i = 1; i < this.expList.length; i++) {
          if(this.expList[i]['startTime']){
            min = new Date(this.expList[i]['startTime']).getTime() <= new Date(min).getTime() ? this.expList[i]['startTime'] : min
          }
          if(this.expList[i]['endTime']){
            max = new Date(this.expList[i]['endTime']).getTime() >= new Date(max).getTime() ? this.expList[i]['endTime'] : max
          }
          
        }
        // console.log(min,max);
        
        let minYear = new Date(min).getFullYear() 
        let minMonth = new Date(min).getMonth() + 1
        let maxYear = new Date(max).getFullYear()
        let maxMonth = new Date(max).getMonth() + 1
        return [{year:minYear , month:minMonth} ,{year:maxYear , month:maxMonth}]
     }
   
  }

  //判断数组內的值是否为连续的
  arrange(source) {
    var t;
    var ta;
    var r = [];
    source.forEach((v)=>{
        if (t === v) {
            ta.push(t);
            t++;
            return;
        }
        ta = [v];
        t = v + 1;
        r.push(ta);
    });
    return r;
  }
  /**
   * 获取每个展览信息盒子的 定位和宽高
   * @param item 
   */
  getPosition(item){
    // debugger
    let left , top , width, height
    let allAdress = [] //该数组的长度，决定了是否连续，1：长度为1，连续且为一个模块； 2：长度大于1，不连续，分为该数组长度值个模块
    let allTop = [] // 1：长度为1，连续且为一个模块； 2：长度大于1，不连续，分为该数组长度值个模块 =》每个模块的top值
    let allHeight = [] // 1：长度为1，连续且为一个模块； 2：长度大于1，不连续，分为该数组长度值个模块 =》每个模块的heigth值
    // 1. 获取 top 
    //定位的高度，要根据涉及到的场馆地点确定，只需要索引最小的地点就可以确定高度
    let addressIndexs = []
    // for(let i=0;i<item.address.length;i++) {
    //   let num = this.addressList.findIndex(v=>v.name == item.address[i])
    //   if(num != -1){
    //     addressIndexs.push(num)
    //   }else {
    //     item.address.slice(i,)
    //   }
    // }
    item.address.forEach(a => {
      let num = this.addressList.findIndex(v=>v.name == a)
      if(num != -1){
        addressIndexs.push(num)
      }
      
    });
    // console.log('addressIndexs')
    // console.log(addressIndexs)
    //若该数据只在一个展厅显示
    if(addressIndexs.length == 1){
      var minIndex = Math.min.apply(null, addressIndexs);
      top = minIndex*50
    }else if(addressIndexs.length > 1) {
      //若在多个展厅展示时，需判断该展厅在列表中，是否为连续的，若连续的则整体展示，若不连续需要分块展示
      //判断依据=》可根据addressIndexs內的数组下标来判断
        addressIndexs.sort((a,b)=>{
        return a-b;
        });
        allAdress = this.arrange(addressIndexs)
        for(let i=0;i<allAdress.length;i++){
          let arr = allAdress[i]
          var minIndex = Math.min.apply(null, arr);
          allTop[i] = minIndex*50
          allHeight[i] = arr.length*50
        }
        // console.log('jjjjj')
        // console.log(allAdress)
        // console.log(allTop)
        // console.log(allHeight)
        // console.log(addressIndexs)
      // var minIndex = Math.min.apply(null, addressIndexs);
      // top = minIndex*50
    }
    let str = ''
    if(addressIndexs.length > 0){
    // 2. 获取 left
        //得到横坐标时间段起始时间
        let day0 = this.rangeList[0]['year'] + '-' + this.rangeList[0]['month'][0] + '-1'
        //计算展览开始时间距离横坐标原点有多少月
        let month1 = ((new Date(item.startTime).getMonth() - new Date(day0).getMonth())) + ((new Date(item.startTime).getFullYear() - new Date(day0).getFullYear())) * 12
        //确定展览开始时间的月份
        let startTimeMonth = new Date(item.startTime).getMonth() + 1
        //确定展览开始时间的那个月的哪一天
        let startTimeDay = new Date(item.startTime).getDate() 
        //确定展览开始时间年份
        let startYear = new Date(item.startTime).getFullYear()
        //看展览开始时间的那个月份一共多少天  new Date(year, month, 0).getDate()
        let startFullDays = new Date(startYear, startTimeMonth, 0).getDate()
        // if( item.name== '新时代建设成就巡礼展'){
        //   console.log(month1,startTimeMonth,startTimeDay,startFullDays);
        // }
        //console.log(month1,startTimeMonth,startTimeDay,startFullDays);
        //注意由于每个月的总天数不一样，但是画格子的时候默认30天，所有要涉及到具体天的时候要使用百分比计算
        //解决bug =>加上 -(1/startFullDays*100)  代表每个月的1号为该格子对应的起始位置（当从1号开始时，默认左边满格开始） 
        //left = month1*100 + startTimeDay / startFullDays *100 + 50 - (1/startFullDays*100)
        left = month1*this.itemWidth + startTimeDay / startFullDays *this.itemWidth  - (1/startFullDays*this.itemWidth)
        
        // 3. 获取 width
        //要先获取 right 然后减去 left 获取到 width
        let right
        //计算展览结束时间距离横坐标原点有多少月 
        let month2 = ((new Date(item.endTime).getMonth() - new Date(day0).getMonth())) + ((new Date(item.endTime).getFullYear() - new Date(day0).getFullYear())) * 12
        //确定展览结束时间的月份
        let endTimeMonth = new Date(item.endTime).getMonth() + 1
        //确定展览结束时间的那个月的哪一天
        let endTimeDay = new Date(item.endTime).getDate() 
        //确定展览结束时间年份
        let endYear = new Date(item.endTime).getFullYear()
        //看展览结束时间的那个月份一共多少天
        let endFullDays = new Date(endYear, endTimeMonth, 0).getDate()
        // console.log(month1,endTimeMonth,endTimeDay,endFullDays);
        //注意由于每个月的总天数不一样，但是画格子的时候默认30天，所有要涉及到具体天的时候要使用百分比计算 this.itemWidth
        //right = month2*100 + endTimeDay / endFullDays *100 + 50
        //解决bug  表格宽度多了2px(结束的日期年月日 为最后一个日期的年月日，让其宽度多加2px)
        if(endYear == this.rangeList[1]['year'] && endTimeMonth == this.rangeList[1]['month'][0] && endTimeDay == endFullDays){
          right = month2*this.itemWidth + endTimeDay / endFullDays *this.itemWidth  + 2
        }else {
          right = month2*this.itemWidth + endTimeDay / endFullDays *this.itemWidth 
        }
        
        width = right - left
        
        //获取高度
        //若该数据只在一个展厅显示
        if(item.address.length == 1){
          height = 50
          str = "<div class='exp'  style='left:"+left+"px;top:"+top+"px;width:"+width+"px;height:"+height+"px;background:"+item.color+";'>"+item.name+"</div>"
        }else {
          for(let i=0;i<allTop.length;i++){
            str+="<div class='exp' style='left:"+left+"px;top:"+allTop[i]+"px;width:"+width+"px;height:"+allHeight[i]+"px;background:"+item.color+";'>"+item.name+"</div>"
          }
        }
    }
  
    //return {left:left+'px' , top:top+'px' , width:width+'px' , height:item.address.length*50+'px',background:item.color}
    return str
  }


 

 
}
